<div class="form-field">
    <span class="desc">{{ title }}</span>
    <input type="checkbox" [(ngModel)]="value" (ngModelChange)="valueChange.emit(value)">
</div>